import { Box, Typography } from '@mui/material';
import { BrzFinanceToggle } from './BrzFinanceToggle';
import { isProductionEnvironment } from '@utils/environment-utils';
import { useTranslation } from 'react-i18next';
import styles from './AppFrameSettingsDialogContent.module.scss';

type SettingsSectionProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
}

function SettingsSection({ title, children, className }: Readonly<SettingsSectionProps>): React.ReactNode {
  return (
    <Box className={`${styles.settingsSection} ${className ?? ''}`}>
      <Typography variant="subtitle1" gutterBottom className={styles.sectionTitle}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

export function AppFrameSettingsDialogContent(): React.ReactNode {
  const { t } = useTranslation('settings');
  const isProduction = isProductionEnvironment();

  if (isProduction) {
    return null;
  }

  return (
    <SettingsSection title={t('settingsDialog.brzFinance')}>
      <BrzFinanceToggle data-testid="settings-brz-finance-toggle" debug={true} />
    </SettingsSection>
  );
}